// Escala de cores das fases: do azul-marinho ao verde-limão.
// Aplicada pelo número da fase, ignorando as cores gravadas no banco,
// para manter a identidade visual do StudySpace em qualquer curso.
export const PHASE_PALETTE = ['#1c2d63', '#34508f', '#4f7ba8', '#7fa800', '#5e7d00', '#2c3f7a', '#8793b8'];

export function getPhaseColor(num) {
  const index = Math.max(0, (Number(num) || 1) - 1);
  return PHASE_PALETTE[index % PHASE_PALETTE.length];
}

// Cor de acento por curso, na ordem de exibição.
export const COURSE_PALETTE = ['#1c2d63', '#7fa800', '#4f7ba8', '#2c3f7a', '#5e7d00'];

export function getCourseColor(index) {
  return COURSE_PALETTE[index % COURSE_PALETTE.length];
}
